// extracted by mini-css-extract-plugin
export default {"Flight__flightProviderImage":"Flight_Flight__flightProviderImage__MjhiZ","Flight__flight":"Flight_Flight__flight__ODUxZ","Flight__flightInfo":"Flight_Flight__flightInfo__M2M5N"};